import { getImageThumbUrl, useMediaUrlWithState } from "hhn-commons";
import React, { CSSProperties } from "react";
import DisplayImage from "./DisplayImage";
import { DisplayMediaProps } from "./DisplayMediaProps";

const DisplayThumbnailImage = ({
  url,
  alt,
  showLoader = true,
  imageContainerStyle,
  isVideoThumbnail,
  ...rest
}: {
  url: string;
  alt: string;
  showLoader?: boolean;
  imageContainerStyle?: CSSProperties;
  isVideoThumbnail?: boolean;
} & DisplayMediaProps) => {
  const thumbnailUrl = isVideoThumbnail ? url : getImageThumbUrl(url);
  // Preload the original signed URL so we can fall back to it if the
  // thumbnail image element fails to load.
  const originalState = useMediaUrlWithState(url);

  const handleError = (
    _: React.SyntheticEvent<HTMLImageElement, Event>,
    setImageSource: (source: string | undefined) => void,
  ) => {
    setImageSource(originalState.data?.signedUrl);
  };

  return (
    <DisplayImage
      url={thumbnailUrl}
      alt={alt}
      onError={handleError}
      showLoader={showLoader}
      containerStyle={imageContainerStyle}
      errorKind={isVideoThumbnail ? "video" : "image"}
      {...rest}
    />
  );
};

export default DisplayThumbnailImage;
